export default __webpack_public_path__ + "static/DidotLTStd-Regular-43fced66df8a7c9fe24f9808a2d49e39.woff";